import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Filtres / réglages — sliders horizontaux duotone */
export const FiltersIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Rails */}
      <path d="M3 7h18M3 12h18M3 17h18" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Curseurs menthe */}
      <circle cx="9" cy="7" r="2.5" fill="var(--equiply-icon-bg)" />
      <circle cx="16" cy="12" r="2.5" fill="var(--equiply-icon-bg)" />
      <circle cx="7" cy="17" r="2.5" fill="var(--equiply-icon-bg)" />
      {/* Contour curseurs */}
      <circle cx="9" cy="7" r="2.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <circle cx="16" cy="12" r="2.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <circle cx="7" cy="17" r="2.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
FiltersIcon.displayName = "FiltersIcon";
